import React from 'react'
import PropTypes from 'prop-types'
import PlayerTime from './PlayerTime'
import './PlayerPlayheadTime.css'

export default class PlayerPlayheadTime extends React.Component {

	constructor(props) {

		super(props)
		this.state = {
			position: 0
		}

		this.onClick = this.onClick.bind(this)
		this.onMouseEnter = this.onMouseEnter.bind(this)
		this.onMouseLeave = this.onMouseLeave.bind(this)
		this.onMouseMove = this.onMouseMove.bind(this)
		this.onMouseDown = this.onMouseDown.bind(this)
		this.onMouseUp = this.onMouseUp.bind(this)
		this.onWindowMouseUp = this.onWindowMouseUp.bind(this)

	}
	
	componentWillUnmount() {
		window.removeEventListener('mouseup', this.onWindowMouseUp)
	}

	onClick( event ) {

		const position = this.getPosition(event.currentTarget, event.clientX)
		const time = this.props.duration * position
		const scrubbing = false
		
		this.props.onSeek({
			scrubbing,
			position,
			time
		})

	}
	
	onMouseDown( event ) {
		
		window.addEventListener('mouseup', this.onWindowMouseUp)
		
		event.preventDefault()
		this.setScrubbing(true)
		
		const position = this.getPosition(event.currentTarget, event.clientX)
		const time = this.props.duration * position
		const scrubbing = true

		this.props.onSeek({
			scrubbing,
			position,
			time
		})
	}
	
	onMouseUp() {
		this.setScrubbing(false)
	}
	
	
	
	onWindowMouseUp() {
		window.removeEventListener('mouseup', this.onWindowMouseUp)
		this.setScrubbing(false)
	}


	onMouseEnter() {
		this.setState({ interactive: true }, () => {
			setTimeout(() => {
				this.setState({ useSmoothTransition: true })
			})
		})

	}

	onMouseLeave() {

		this.setState({
			interactive: false,
			useSmoothTransition: false,
		})

	}

	onMouseMove( event ) {

		if ( !this.state.interactive ) { return }
		const position = this.getPosition(event.currentTarget, event.clientX)
		const time = Math.floor(this.props.duration * position)

		this.setState({
			position,
			time,
		})
		
		if (this.state.scrubbing) {
			this.props.onSeek({
				scrubbing: true,
				position,
				time
			})
		}
	}
	
	setScrubbing( value ) {
		this.setState({ scrubbing: value })
		this.props.onScrubb && this.props.onScrubb(value)
	}

	getPosition( target, clientX ) {
		const rect = target.getBoundingClientRect()
		return (clientX - rect.left) / rect.width
	}

	render() {

		let { time, duration } = this.props

		if ( true || (this.state.interactive && this.state.position) ) {
			time = Math.round(this.state.position * duration)
		}

		// const position = time / duration

		const playheadStyle = {
			position: 'absolute',
			opacity: this.state.interactive 
				&& (this.state.position >= 0 && this.state.position <= 1) 
				? 1 : 0,
			left: `${ this.state.position * 100}%`,
			transform: 'translateX(-50%)',
		}

		return (
			<div
				onClick={ this.onClick }
				onMouseEnter={ this.onMouseEnter }
				onMouseLeave={ this.onMouseLeave }
				onMouseDown={ this.onMouseDown } 
				onMouseUp={ this.onMouseUp }
				onMouseMove={ this.onMouseMove }
				className="player-ctrl--playhead"
				>
				<div 
					className="player-ctrl--playhead__cursorcontainer" 
					>
					<div 
						className="player-ctrl--playhead__cursor" 
						style={ playheadStyle }
						>
						<PlayerTime time={ time } duration={ duration } />
					</div>
				</div>
			</div>
		)
	}
}

PlayerPlayheadTime.props = {
	time: PropTypes.number,
	duration: PropTypes.number,
	onSeek: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/components/player/controls/time/PlayerPlayheadTime.jsx